module.exports = __webpack_public_path__ + "img/5.9598bac4.png";